import React, { useEffect, useRef, useState } from "react";
import { Button, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import Typography from "@mui/material/Typography";
import RefundPopup from "./RefundPopup";
import { useNavigate, useParams } from "react-router";
import { ticketsAction } from "../../../services/TicketsServices";
import Card from "@mui/material/Card";
import Moment from "react-moment";
import WristBandDesign from "../../../view/Landing/TicketDesignPrinting/WristBandDesign";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import headerImg from "../../../assets/Images/pdfHeader.png";
import footerImg from "../../../assets/Images/pdfBG.png";
import Barcode from "react-barcode";
import TicketsAduitTrial from "./TicketsAduitTrial";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { ticketsActivityLog } from "../../../services/TicketsServices";
import PageWrapper from "../../../common/PageWrapper/PageWrapper";

export default function TicketDetail() {
  const navigate = useNavigate();
  const params = useParams();
  const id = params?.id;
  const [open, setOpen] = useState(false);
  const [ticket, setTicket] = useState({});
  const [activityLogs, setActivityLogs] = useState([]);
  const [showDownloadButton, setShowDownloadButton] = useState(true);
  const componentRef = useRef();
  const ticketRef = useRef();
  const [openLog, setOpenLog] = useState(false);
  const [changeIndex, setChangeIndex] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);

  const latestRefundNote = activityLogs
    ?.find((l) => ["request_refund", "approve_refund", "reject_refund"].includes(l?.transition))
    ?.description;

  useEffect(() => {
    getTicketDetail();
  }, []);

  useEffect(() => {
    if (!id) return;
    ticketsActivityLog("get", id)
      .then((res) => {
        setActivityLogs(res?.data || []);
      })
      .catch(() => {
        setActivityLogs([]);
      });
  }, [id]);

  const getTicketDetail = () => {
    ticketsAction("get", id).then((res) => {
      setTicket(res?.data);
    });
  };

  const toggleLog = () => {
    setOpenLog(!openLog);
  };

  const handleLogClose = () => {
    setOpenLog(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleDownloadPDF = () => {
    setShowDownloadButton(false);
    const input = ticketRef.current;

    html2canvas(input, { scale: 2 })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = 300;
        const imgHeight = 200;
        let heightLeft = imgHeight;

        const ticketX = (pageWidth - imgWidth) / 2 + 55;
        const ticketY = (pageHeight - imgHeight) / 2 - 10;

        const headerImage = new Image();
        headerImage.src = headerImg;
        const headerHeight = 40;

        const footerImage = new Image();
        footerImage.src = footerImg;
        const footerHeight = 45;

        headerImage.onload = () => {
          pdf.addImage(headerImage, "PNG", 0, 0, pageWidth, headerHeight);
          pdf.addImage(imgData, "PNG", ticketX, ticketY, imgWidth, imgHeight);

          const footerTextY = pageHeight - footerHeight - 8;
          pdf.setFontSize(13);
          pdf.setTextColor("#08254F");
          pdf.setFont("helvetica", "italic");
          pdf.text("Museum staff will scan the barcode to grant you entry into the museum", 35, footerTextY);

          footerImage.onload = () => {
            pdf.addImage(footerImage, "PNG", 0, pageHeight - footerHeight, pageWidth, footerHeight);
            pdf.save("ticket-details.pdf");
            setShowDownloadButton(true);
          };
        };
      })
      .catch((error) => {
        console.error("Error generating PDF: ", error);
        setShowDownloadButton(true);
      });
  };

  return (
    <PageWrapper>
      <Box className={"space-between"} sx={{ marginTop: 5 }}>
        <Box onClick={() => navigate(-1)} className={"flex-cx-center hand-cursor"}>
          <ArrowBackIosRoundedIcon fontSize={"small"} sx={{ color: "#757575" }} />
          <Typography variant={"h5"} sx={{ color: "#757575", fontSize: 14 }}>
            Back
          </Typography>{" "}
          &nbsp;
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          {" "}
          {/* Flex container for buttons */}
          <Button onClick={handleOpen} variant={"contained"}>
            Refund
          </Button>
          <Button variant={"contained"} onClick={handleDownloadPDF}>
            Download PDF
          </Button>
        </Box>
      </Box>
      <Box className={"header-divider"} />
      <RefundPopup open={open} handleClose={handleClose} ticketId={id} />


      
      <Grid container spacing={2}>
        <Grid item sm={5}>
          <Box 
            sx={{ 
              transform: 'scale(0.75)',     
              transformOrigin: 'top center', 
              marginBottom: '-50px'         
            }}
          >
          <WristBandDesign ref={componentRef} ticket={ticket} />
          </Box>
          <div className={"justify"}>
            <Button sx={{ mt: 2 }} variant={"contained"} onClick={handlePrint}>
              Print ticket
            </Button>
          </div>
        </Grid>



        <Grid item sm={7}>
          <Card sx={{ p: 4 }} ref={ticketRef}>
            {" "}
            {/* Set ref here for ticket details */}
            <Grid container spacing={2}>
              <Grid item sm={6}>
                <Typography>
                  Museum Notes:{" "}
                  <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{ticket?.museum_name}</span>
                </Typography>
                <Typography>
                  No. of visitors:{" "}
                  <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{ticket?.no_of_visitor}</span>
                </Typography>
                {ticket?.exhibitions && ticket?.exhibitions?.length > 0 && (
                  <Typography>
                    Exhibition(s):{" "}
                    <span style={{ fontWeight: 600 }}>
                      {ticket.exhibitions.map((e) => e.name).join(", ")}
                    </span>
                  </Typography>
                )}
                {ticket?.exhibitions?.length > 0 && ticket?.discount_amount && parseFloat(ticket.discount_amount) > 0 && (
                  <Typography>
                    Discount amount:{" "}
                    <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{ticket?.discount_amount}</span>
                  </Typography>
                )}
                <Typography>
                  Payment amount:{" "}
                  <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{ticket?.payment_due}</span>
                </Typography>
                <Typography>
                  Payment type:{" "}
                  <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{ticket?.payment_type}</span>
                </Typography>
                <Typography>
                  Ticket number:{" "}
                  <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{ticket?.ticket_no}</span>
                </Typography>
                                <Typography>
                  Visitor type:{" "}
                  <span style={{ fontWeight: 600, textTransform: "capitalize" }}>
                    {ticket?.visitor_type_detail?.name || ticket?.visitor_type?.name || ticket?.visitor_type_name || ticket?.ticket_type_detail?.visitor_type?.name || '-'}
                  </span>
                </Typography>
                {ticket?.payment_type === "electronic" && (
                  <Typography>
                    Transaction number:{" "}
                    <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{ticket?.transaction_no}</span>
                  </Typography>
                )}
                <Typography>
                  Guide Name: <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{ticket?.guide_name || ticket?.guide_detail?.name || "No Guide"}</span>
                </Typography>
                <Typography>
                  Guide Number:{" "}
                  <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{ticket?.guide_phone || ticket?.guide_detail?.phone || "No Guide"}</span>
                </Typography>
                <Typography>
                  Guide Agent:{" "}
                  <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{ticket?.guide_agent_name || ticket?.guide_detail?.agent_name || "No Agent"}</span>
                </Typography>
                <Typography>
                  Validity:{" "}
                  <span style={{ fontWeight: 600, textTransform: "capitalize" }}>
                    <Moment format={"ll"}>{ticket?.validity}</Moment>
                  </span>
                </Typography>
                {latestRefundNote && (
                  <Typography>
                    Refund Note:{" "}
                    <span style={{ fontWeight: 600, textTransform: "capitalize" }}>{latestRefundNote}</span>
                  </Typography>
                )}
                <Grid container sx={{ mt: -11 }}>
                  <Grid item sm={7.8}>
                    <div ref={componentRef} className="ticket-template-rp">
                      <Barcode
                        format={"EAN13"}
                        font={"monospace"}
                        fontSize={50}
                        height={300}
                        ean128={true}
                        width={7.2}
                        value={ticket?.ticket_no}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
      
      <Box sx={{ position: "fixed", right: 0, bottom: "10%" }}>
        <Card
          onClick={toggleLog}
          className={"box-shadow"}
          sx={{
            pr: 2.5,
            pl: 2,
            pt: 1.5,
            pb: 1.5,
            zIndex: 20000,
            backgroundColor: '#616B88',
            borderTopLeftRadius: 50,
            borderBottomLeftRadius: 50,
            cursor: 'pointer',
          }}
        >
          <ArrowBackIosNewRoundedIcon fontSize={"small"} sx={{ color: "#fff" }} />
        </Card>
      </Box>
      <TicketsAduitTrial openLog={openLog} handleLogClose={handleLogClose} id={id} />
    </PageWrapper>
  );
}
